import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft } from "lucide-react";
import { WaitlistDialog } from "../components/WaitlistDialog";
import { Button } from "../components/ui/button";
import { Seo } from "../components/Seo";

export default function ArticleDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => navigate("/resources"));
  }, [slug, navigate]);

  if (!article)
    return <div className="min-h-[60vh] flex items-center justify-center text-forest">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 py-14" data-testid="article-detail-page">
      <Seo
        title={article.title}
        description={article.excerpt || `${article.title} — an article from Laura Combs Productions.`}
        path={`/blog/${article.slug}`}
        image={article.cover_image || undefined}
        type="article"
      />
      <Link to="/blog" className="flex w-fit items-center gap-2 text-charcoal/60 hover:text-forest mb-8 text-sm">
        <ArrowLeft className="w-4 h-4" /> All posts
      </Link>

      <span className="text-gold text-xs uppercase tracking-[0.3em]">{article.category}</span>
      <h1 className="font-serif text-4xl sm:text-5xl text-forest mt-4 leading-tight">{article.title}</h1>
      <p className="text-charcoal/50 text-sm mt-4">
        {new Date(article.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })} · Laura Combs
      </p>

      <div className="rounded-2xl overflow-hidden shadow-lg my-10 aspect-[16/9]">
        <img src={article.cover_image || "https://images.unsplash.com/photo-1458014854819-1a40aa70211c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"} alt={article.title} className="w-full h-full object-cover" />
      </div>

      <div className="prose-lcp space-y-6">
        {article.content.split("\n\n").map((para, i) => (
          <p key={i} className="text-charcoal/80 text-lg leading-relaxed">{para}</p>
        ))}
      </div>

      <div className="mt-14 bg-forest rounded-2xl p-10 text-center text-ivory">
        <h3 className="font-serif text-3xl">Enjoyed this?</h3>
        <p className="text-ivory/80 mt-3 max-w-md mx-auto">
          Join the community to receive new reflections and be the first to know when
          Welcome to Adulthood launches.
        </p>
        <WaitlistDialog source={`article:${article.slug}`}>
          <Button className="rounded-full bg-gold hover:bg-gold/90 text-forest px-8 h-12 mt-6 transition-colors" data-testid="article-join-btn">
            Join the Community
          </Button>
        </WaitlistDialog>
      </div>
    </article>
  );
}
